import React, { Component } from "react";

export class TermsAndConditions extends Component {
    render() {
        return (
            <div id="Container">
                    <div className="group-form">
                        <h4>POLÍTICAS DE MANEJO DE DINEROS LIFE CEL COLOMBIA</h4>
                    </div>
                    <div className="group-form">
                        <p>
                            En LIFE CEL temenos diferentes modalidades de pago: FULL LIFE Y
                            PROMO LIFE. Al momento de la inscripción el participante puede elegir
                            cuál es la opción funcional. Cada una tiene diferentes beneficios y
                            restricciones.
                        </p>
                    </div>
                    <div className="group-form">
                        <p><b>Tabla comparativa entre los valores de inscripción</b></p>
                        <p>
                            Esta tabla representa los beneficios que tiene el tipo de pago que usted realizó, si tiene duda de cuál es su estado de
                            pago puede preguntarle a nuestro coordinador.
                        </p>
                        <table className="responsive text-center">
                            <thead>
                                <tr>
                                    <td className="border col-lg-1">
                                        Beneficios
                                    </td>
                                    <td className="border col-lg-2">Transferencia
                                        de dinero
                                    </td>
                                    <td className="border col-lg-3"> Cambio de fecha para la
                                        misma cohorte
                                    </td>
                                    <td className="border col-lg-3"> Cambio de fecha
                                        hasta por 6 meses
                                        siguientes a la
                                        inscripción
                                    </td>
                                    <td className="border col-lg-3"> Devolución
                                        de dinero
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="border">Full Life</td>
                                    <td className="border"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
                                        <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
                                        <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
                                    </svg></td>
                                    <td className="border"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
                                        <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
                                        <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
                                    </svg></td>
                                    <td className="border"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
                                        <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
                                        <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
                                    </svg></td>
                                    <td className="border"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
                                        <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
                                        <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
                                    </svg></td>
                                </tr>
                                <tr>
                                    <td className="border">Promo Life</td>
                                    <td className="border"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
                                        <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
                                        <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
                                    </svg></td>
                                    <td className="border"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
                                        <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
                                        <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
                                    </svg></td>
                                    <td className="border"></td>
                                    <td className="border"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="group-form">
                        <p><b>FULL LIFE</b></p>
                        <p>
                            Es nuestro precio estrella. En esta modalidad el participante puede
                            realizar transferencia de dineros a otros participantes inscritos, cambiar la
                            fecha para realizar los entrenamientos en la misma cohorte, aplazar el
                            entrenamiento, hasta por 6 meses siguientes a la inscripción, y solicitar la
                            devolución del dinero en cualquier momento, sin justificaciones.
                        </p>

                        <p><b>PROMO LIFE</b></p>
                        <p>
                            Es nuestra modalidad de precios especiales. El participante solo puede
                            solicitar la transferencia de dineros o cambiar las fechas para la misma
                            cohorte. No aplica el aplazamiento hasta por 6 meses o la devolución
                            incondicional del dinero.
                        </p>
                    </div>
                    <div className="group-form">
                        <p><b>TRANSFERENCIA DE DINERO</b></p>
                        <p>
                            El participante que no pueda o no quiera continuar con el entrenamiento
                            podrá, hasta antes de iniciar el entrenamiento para el que fue inscrito,
                            solicitar que el dinero pagado por concepto de matricula se transfiera a
                            otro participante inscrito, para el mismo nivel de entrenamiento, de
                            acuerdo con las siguientes condiciones:
                        </p>

                        <p>
                            1.	La transferencia de dinero solo aplica para los entrenamientos activos
                            en las mismas fechas a las que se inscribió inicialmente el
                            participante.
                        </p>
                        <p>
                            2.	El participante a quien se le transfiere el dinero debe estar inscrito.
                        </p>
                        <p>
                            3.	Solamente se puede transferir dinero para entrenamientos de la
                            misma categoría: básico a básico; avanzado a avanzado; PL a PL.
                        </p>
                        <p>
                            La solicitud de transferencia de dinero se podrá hacer directamente a
                            través del WhatsApp o por comunicación directa con el coordinador.
                        </p>

                        <p><b>CAMBIO DE FECHA</b></p>

                        <p>
                            El participante puede cambiar de sede para realizar el entrenamiento,
                            solamente para la misma cohorte. Sujeto a disponibilidad y restricciones
                            de aforo para la sede que solicita el cambio. Para PROMO LIFE solo se
                            puede pedir el cambio de fecha hasta antes de iniciar el entrenamiento.
                            Para FULL LIFE se puede en cualquier momento, siempre y cuando no
                            se afecte el desarrollo del entrenamiento.
                        </p>

                        <p><b>CAMBIO DE FECHA HASTA POR 6 MESES</b></p>
                        <p>
                            Los participantes que hayan pagado FULL LIFE pueden aplazar el inicio
                            del entrenamiento hasta por 6 meses, contados a partir de la inscripción.
                        </p>

                        <p><b>DEVOLUCIÓN DE DINERO</b></p>
                        <p>
                            Cuando LIFE C.E.L cancele el entrenamiento por no haber alcanzado el
                            número mínimo de participantes devolverá el 100% del dinero pagado. El
                            reintegro se realizará dentro de los 5 días hábiles siguientes a la
                            cancelación del entrenamiento, por el medio que indique el participante.
                            Si el entrenamiento se cancela por el hecho de un tercero, caso fortuito o
                            fuerza mayor, LIFE CEL reprogramará el entrenamiento.
                        </p>

                        <p>
                            Después de que haya iniciado el entrenamiento no habrá lugar a ningún
                            tipo devolución de dinero, ni transferencia de dinero, ni cambio de
                            fechas. Para la modalidad FULL LIFE se puede solicitar la devolución
                            completa del dinero, en cualquier momento.
                        </p>
                        <p>
                            El participante solo puede ejercer el derecho al retracto cuando el
                            entrenamiento se haya convenido por medio de alguna de las
                            modalidades <b>previstas en el artículo 47 de la Ley 1480 de 2011.</b>
                        </p>
                        <p>
                            El consumidor no podrá́ ejercer el derecho de retracto cuando el servicio
                            haya comenzado a prestarse con su consentimiento o cuando entre el
                            momento en que se ejerza el derecho de retracto y la fecha pactada para
                            el inicio de la prestación del servicio medien menos de cinco (5) días.
                        </p>
                        <p>
                            El término máximo para ejercer el derecho de retracto será́ de cinco (5)
                            días hábiles contados a partir de la celebración del contrato en caso de la
                            prestación de servicios. Si procede el derecho al retracto, se devolverán
                            todas las sumas pagadas. Sin exceder (30) días calendario desde el
                            momento en que ejerció el derecho.
                        </p>
                        <p>
                            Manifiesto que el presente documento lo tuve a mi disposición durante
                            el tiempo que estimé necesario. Cada uno de los párrafos los comprendí,
                            y el equipo de LIFE CEL estuvo atento para responder todas mis
                            preguntas, inquietudes y sugerencias.
                        </p>
                    </div>
            
            </div>
        )
    }
}